import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import useAwardSocialLinks from '../../../hooks/useAwardSocialLinks';
import UsageTracker from '../../../utils/UsageTracker';
import { useTrack } from '../../tracks';
import getLang from 'LearningCenterUI/utils/getLang';
import { useTrackAwardProgress } from '../../userProgress';
import { useAchievementStatus } from '../achievementHooks';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { SocialBlockFacebookIcon, SocialBlockLinkIcon, SocialBlockLinkedinIcon, SocialBlockXIcon } from 'foundations-assets';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const socialShareButtonDefinitions = [{
  networkName: 'facebook',
  hrefKey: 'facebook',
  icon: /*#__PURE__*/_jsx(SocialBlockFacebookIcon, {
    color: "do-not-use-facebook",
    size: "1000"
  }),
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.awardShareControls.facebook"
  })
}, {
  networkName: 'linkedin',
  hrefKey: 'linkedin',
  icon: /*#__PURE__*/_jsx(SocialBlockLinkedinIcon, {
    color: "do-not-use-linkedin",
    size: "1000"
  }),
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.awardShareControls.linkedinPost"
  })
}, {
  networkName: 'linkedin',
  hrefKey: 'linkedinAddToProfile',
  icon: /*#__PURE__*/_jsx(SocialBlockLinkedinIcon, {
    color: "do-not-use-linkedin",
    size: "1000"
  }),
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.awardShareControls.linkedinLicenses"
  })
}, {
  networkName: 'x',
  hrefKey: 'x',
  icon: /*#__PURE__*/_jsx(SocialBlockXIcon, {
    color: "do-not-use-x",
    size: "1000"
  }),
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.awardShareControls.xSocialNetwork"
  })
}];
const SocialShareButtons = ({
  trackId,
  language
}) => {
  const shareLinks = useAwardSocialLinks(trackId.toString(), language);
  const {
    track
  } = useTrack(Number(trackId), getLang());
  const {
    award
  } = useTrackAwardProgress(Number(trackId));
  const {
    isDisabled
  } = useAchievementStatus(trackId.toString());
  const onSocialShareClick = useCallback((socialName, destinationUrl) => {
    if (destinationUrl) {
      window.open(destinationUrl, '_blank');
    }
    if (!award) return;
    UsageTracker.track('awardInteraction', {
      action: 'social-share',
      trackId: track ? track.id : null,
      trackName: track ? track.name : null,
      view: 'sharing-controls',
      socialName,
      destinationUrl: destinationUrl || ''
    });
  }, [award, track]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexWrap: "wrap",
    gap: "300",
    justifyContent: "center",
    children: [shareLinks && socialShareButtonDefinitions.map(({
      networkName,
      hrefKey,
      icon,
      buttonText
    }) => /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      inlineSize: "178px",
      children: /*#__PURE__*/_jsx(SelectableButton, {
        "data-test-id": "social-sharing-option",
        "data-test-url": shareLinks[hrefKey],
        disabled: isDisabled,
        onClick: () => onSocialShareClick(networkName, shareLinks[hrefKey]),
        selected: false,
        size: "lg",
        title: buttonText,
        children: icon
      })
    }, `${networkName}-${hrefKey}`)), /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(CopyButton, {
        use: "unstyled",
        value: shareLinks === null || shareLinks === void 0 ? void 0 : shareLinks.achievementUrl,
        children: /*#__PURE__*/_jsx(SelectableButton, {
          disabled: isDisabled,
          minInlineSize: "178px",
          onClick: () => onSocialShareClick('copy-link', shareLinks === null || shareLinks === void 0 ? void 0 : shareLinks.achievementUrl),
          selected: false,
          size: "lg",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.awardShareControls.copyLink"
          }),
          children: /*#__PURE__*/_jsx(SocialBlockLinkIcon, {
            color: "icon-core-subtle",
            size: "1000"
          })
        })
      })
    })]
  });
};
export default SocialShareButtons;